import {browserHistory} from 'react-router';
import SearchInputActions from 'actions/search/SearchInputActions';
import CallActions from 'actions/CallActions';
import {scrollToTop} from 'utils/scrollToTop';

/**
 * Given a set of callIds perform a search then navigate to /calls and display them
 */
export function showCalls(callIds, limitWarning, backUrl, backText) {
  // Clear any existing search criteria
  SearchInputActions.clearSearchInputValue.defer();
  CallActions.clearSearch.defer();
  CallActions.setDrilldown([backUrl, backText, limitWarning, callIds]);
  CallActions.updateFileId.defer(callIds);

  browserHistory.push({
    pathname: '/calls/my',
  });

  scrollToTop();
}
